import 'css-chunk:src/applications/ProductFulfillmentApp/pages/ProductFulfillmentApp.styles.scss';export default {
  "productFulfillmentAppModal": "_productFulfillmentAppModal_oy0ec_1"
};